(async function () {
  const url = new URL(location.href);
  const order = url.searchParams.get('sort_by');
  const brand = url.searchParams.get('fsd_brand') || '';
  const brandSelect = document.querySelector('select[name="fsd_brand"]');
  if (brandSelect) brandSelect.value = brand;
  if (!brand && order !== 'price-ascending' && order !== 'price-descending') return;
  const section = document.getElementById('CollectionSection');
  if (!section) return;
  const grid = section.querySelector('.grid-uniform');
  const status = document.getElementById('fsd-sort-status');
  const pageSize = Number(section.dataset.pageSize);
  const currentPage = Number(url.searchParams.get('page') || 1);
  if (!grid || !pageSize || !status) return;
  status.hidden = false;
  grid.setAttribute('aria-busy', 'true');
  try {
    async function readPage(page) {
      const request = new URL(url);
      request.searchParams.set('view', 'fsd-price-data');
      request.searchParams.set('page', String(page));
      const response = await fetch(request, {credentials: 'same-origin'});
      if (!response.ok) throw new Error('Catalog unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const root = doc.querySelector('[data-price-pages]');
      if (!root) throw new Error('Catalog incomplete');
      return root;
    }
    const first = await readPage(1);
    const pages = Number(first.dataset.pricePages);
    const expected = Number(first.dataset.priceCount);
    const roots = [first];
    for (let page = 2; page <= pages; page += 2) {
      roots.push(...await Promise.all(Array.from({length: Math.min(2, pages - page + 1)}, (_, i) => readPage(page + i))));
    }
    let cards = roots.flatMap(root => Array.from(root.querySelectorAll('[data-product-id]')));
    if (cards.length !== expected || new Set(cards.map(card => card.dataset.productId)).size !== expected) throw new Error('Catalog incomplete');
    const price = card => Number(card.querySelector('[data-display-price]').dataset.displayPrice);
    if (cards.some(card => !Number.isFinite(price(card)))) throw new Error('Price unavailable');
    if (brand) cards = cards.filter(card => card.dataset.vendor === brand);
    if (order === 'price-ascending' || order === 'price-descending') {
      const direction = order === 'price-ascending' ? 1 : -1;
      cards.sort((a, b) => direction * (price(a) - price(b)) || a.dataset.productId.localeCompare(b.dataset.productId));
    }
    const visible = cards.slice((currentPage - 1) * pageSize, currentPage * pageSize);
    grid.replaceChildren(...visible);
    grid.querySelectorAll('.js-extra30-coupon').forEach(input => {
      input.checked = input.checked || sessionStorage.getItem('fsd-extra30-selected') === 'true';
    });
    if (brand) {
      const total = Math.max(1, Math.ceil(cards.length / pageSize));
      let nav = section.querySelector('nav.pagination');
      if (!nav) { nav = document.createElement('nav'); nav.className = 'pagination text-center'; section.append(nav); }
      const links = [];
      for (let page = 1; page <= total; page++) {
        const link = document.createElement('a');
        const target = new URL(url); target.searchParams.set('page', String(page));
        link.href = target.href; link.textContent = String(page); link.style.margin = '0 8px';
        if (page === currentPage) link.setAttribute('aria-current', 'page');
        links.push(link);
      }
      nav.replaceChildren(...links);
    }
    status.hidden = true;
  } catch (error) {
    status.textContent = status.dataset.error;
  } finally {
    grid.removeAttribute('aria-busy');
  }
})();